import { getDailyData } from "../api/PLTH/getDailyData.ts"
import { getFlowRateDisplayData } from "../api/PLTH/getFlowRateDisplayData.ts"
import { getMonthlyData } from "../api/PLTH/getMonthlyData.ts"

import type { SummaryRowConfig } from "../types/summaryRowTypes.ts"

export const PLTHFetchers: SummaryRowConfig = {
  flowRateFetcher: getFlowRateDisplayData,
  dailyFetcher: getDailyData,
  monthlyFetcher: getMonthlyData,
  flowThresholds: [750, 1000, 1250, 1500],
}
